import { COUNTRY_CODES } from "../../../../constants/countries";

/**
 * El correo del cliente, obligatorio para que un documento salga hacia Business
 * Central.
 *
 * Regla de Santillana Costa Rica (13/09/2026): un tiquete, una factura o una nota
 * de crédito sin correo electrónico del cliente no se envía. Se comprueba en el
 * tronco de la sincronización --por donde pasan los cuatro caminos a Business
 * Central-- junto a lo que Hacienda rechazaría, y como eso no se reintenta: el
 * documento se queda entero en el terminal hasta que alguien capture el correo.
 *
 * Sólo se exige que exista. Que tenga un formato válido lo decide `revisarCorreo`,
 * con la regla de los Anexos de Hacienda.
 *
 * @param {object} documento La cabecera local, con `E_Mail`.
 * @param {string} countryCode El país activo.
 * @returns {boolean}
 */
export const faltaElCorreoDelCliente = (documento, countryCode) =>
  countryCode === COUNTRY_CODES.COSTARICA && !String(documento?.E_Mail ?? "").trim();
